import script from "./bindRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./bindRoom.vue?vue&type=script&setup=true&lang=js"

import "./bindRoom.vue?vue&type=style&index=0&id=5eb475d2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb475d2"]])

export default __exports__